/**
 * For now adding in this core package,
 * ideally it should be migrated to shared/provider in the future
 */
import { createContext, useContext } from 'react';
var ContentFulDataContext = /*#__PURE__*/createContext({
  value: {},
  children: null
});
export var ContentFulDataProvider = ContentFulDataContext.Provider;
export var useContentfulData = function useContentfulData() {
  return useContext(ContentFulDataContext);
};